import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { CityService } from "src/app/cities/cities.service";
import { City } from "src/app/cities/city";
import { Observable, empty } from "rxjs";
import {
  tap,
} from "rxjs/operators";
import {
  Columns,
  Config,
  DefaultConfig,
} from "ngx-easy-table";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import {
  faEdit,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { MessagerComponent } from "src/app/messager/messager/messager.component";
import { GridDeleteComponent } from "src/app/utils/grid-delete-component";
import { GlobalEmailService } from "src/app/utils/globalemail.service";
import { LoggingService } from "src/app/utils/logging.service";
import { AuthService } from "src/app/auth.service";
import { _DROPDOWN_US_STATES } from "../../utils/constants"; 

export interface State {
  value: string;
  viewValue: string;
}

export interface Region {
  value: string;
  viewValue: string;
}

@Component({
  selector: "app-edit-city",
  templateUrl: "./edit-cities-dialog.html",
  styleUrls: ["./cities.component.css"],
})
export class EditCityDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<EditCityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: City,
    private fb: FormBuilder,
    public service: CityService,
    private messager: MessagerComponent,
    public log: LoggingService,
    public ges: GlobalEmailService
  ) {}

  states = this.data.states;
  regions = this.data.regions;

  form = new FormGroup({
    city_id: new FormControl(this.data.city_id || 0),
    city: new FormControl(this.data.city || ""),
    state: new FormControl(this.data.state || ""),
    region: new FormControl(this.data.region || ""),
    elevation: new FormControl(this.data.elevation || 0),
    county: new FormControl(this.data.county || ""),
    multiplecz: new FormControl(this.data.multiplecz || false),
    defaultcz: new FormControl(this.data.defaultcz || 0),
  });

  @ViewChild("refname", { read: false, static: false })
  refNameInputRef: ElementRef;
  mode = this.data.mode;
  isLoading = false;

  ngOnInit() {
    //pre-fill dropdowns here
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save(): void {

    let changedProperties = [];
    Object.keys(this.form.controls).forEach((name) => {
      const currentControl = this.form.controls[name];

      if (currentControl.dirty) {
        changedProperties.push(name + ": " + this.form.controls[name].value);
      }
    });

    this.service.saveEdit(this.data.city_id, this.form.value).subscribe(
      (res) => {
        if (res.Error) {
          let errMessage = res.Message;

          this.messager.openSnackBar(
            "Error saving city, an email with all data has been sent to support.",
            "[close]",
            "errorAlert"
          );

          this.ges
            .sendDebugEmail(
              "IMPORTANT",
              this.form.value,
              "Jobs via Locations",
              errMessage
            )
            .subscribe(
              (res) => {
                if (res.Error) {
                  this.log.error(
                    "Error sending debug email for cities page: " + res.Message
                  );
                } else {
                  this.log.debug(
                    "Debug email sent to support from the cities page."
                  );
                }
              },
              (err) => {
                this.log.error(
                  "Application error sending debug email: " + err.toString()
                );
              }
            );

          this.log.error(
            this.data.usernamee +
              " encountered an error editing a city: Submitted data: " +
              "{" +
              this.form.value.toString() +
              "} " +
              res.Message
          );
        } else {
          this.log.info(
            this.data.usernamee +
              " saved the following edits to the city " +
              this.data.city +
              "with id: " +
              this.data.city_id +
              " {" +
              changedProperties.toString() +
              "}"
          );

          this.dialogRef.close();
        }
      },
      (err) => {
      }
    );
  }

  add(): void {

    this.service.add(this.form.value).subscribe(
      (res) => {
        if (res.Error) {
          let errMessage = res.Message;

          this.messager.openSnackBar(
            "Error saving city, an email with all data has been sent to support.",
            "[close]",
            "errorAlert"
          );

          this.ges
            .sendDebugEmail("IMPORTANT", this.form.value, "Cities", errMessage)
            .subscribe(
              (res) => {
                if (res.Error) {
                  this.log.error(
                    "Error sending debug email for cities page: " + res.Message
                  );
                } else {
                  this.log.debug(
                    "Debug email sent to support from the cities page."
                  );
                }
              },
              (err) => {
                this.log.error(
                  "Application error sending debug email: " + err.toString()
                );
              }
            );

          this.log.error(
            this.data.usernamee +
              " attempted to add a job but encountered an error, submitted data: " +
              this.form.value.toString() +
              " - Error:- " +
              res.Message
          );
        } else {
          try {
            this.log.info(
              this.data.usernamee +
                " created city " +
                this.form.value.city +
                " city_id: " +
                res.id
            );
          } catch (error) {
          }
        }

        this.dialogRef.close();
      },
    );
  }
}

@Component({
  selector: "app-cities",
  templateUrl: "./cities.component.html",
  styleUrls: ["./cities.component.css"],
})
export class CitiesComponent implements OnInit {
  public configuration: Config;
  public columns: Columns[];
  editData;

  faedit = faEdit;
  fatrash = faTrashAlt;

  modal = false;
  selected;


  states: State[] = _DROPDOWN_US_STATES;
  regions: Region[] = [];

  gridEntrie$: Observable<City[]>;
  displayedColumns: string[] = ["city", "state", "region", "elevation"];

  user;
  usernamee;

  constructor(
    public cityService: CityService,
    public dialog: MatDialog,
    public log: LoggingService,
    public auth: AuthService
  ) {}

  ngOnInit(): void {

    this.cityService.init();

    this.configuration = { ...DefaultConfig };
    this.configuration.tableLayout.theme = "lIGHT";
    this.configuration.tableLayout.style = "big";
    this.configuration.tableLayout.borderless = false;
    this.configuration.tableLayout.hover = true;
    this.configuration.searchEnabled = true;
    this.configuration.paginationEnabled = true;
    this.configuration.paginationRangeEnabled = false;
    this.configuration.isLoading = true;
    this.configuration.rows = 100;

    this.gridEntrie$ = this.cityService.getInitial().pipe(
      tap(() => {
        this.configuration.isLoading = this.cityService.isLoading;
      })
    );

    this.columns = [
      { key: "", title: "", searchEnabled: false }, 
      { key: "city", title: "City" },
      { key: "state", title: "State" },
      { key: "region", title: "Region" },
      { key: "elevation", title: "Elevation" },
    ];

    this.cityService.getRegions().subscribe(data => {
      this.regions = data;
    });

    this.auth.userProfile$.subscribe(
      (profile) => {

        this.user = profile;
        this.usernamee = this.user
          ? this.user.nickname.charAt(0).toUpperCase() +
            this.user.nickname.slice(1)
          : "";
      },
      (err) => {
      }
    );
  }

  openDialog(myData): void {
    this.cityService.getOneCity(myData.city_id).subscribe((tdata: any) => {

      const dialogRef = this.dialog.open(EditCityDialogComponent, {
        width: "400px",
        data: {
          city_id: tdata.City.city_id,
          city: tdata.City.city,
          state: tdata.City.state,
          region: tdata.City.region?.trim(),
          elevation: tdata.City.elevation,
          county: tdata.City.county,
          defaultcz: tdata.City.defaultcz,
          multiplecz: tdata.City.multiplecz,
          usernamee: this.usernamee || "User",
          mode: 1,
          states: this.states,
          regions: this.regions,
        },
        panelClass: 'edit-dialog-container'
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.editData = result;
      });
    });
  }

  addDialog(): void {
    const dialogRef = this.dialog.open(EditCityDialogComponent, {
      width: "400px",
      height: "80vw",
      data: {
        states: this.states,
        regions: this.regions,
        usernamee: this.usernamee || "User",
        mode: 2,
      },
      panelClass: 'edit-dialog-container'
    });
  }

  delete(object: City): void {
    const dialogRef = this.dialog.open(GridDeleteComponent, {
      width: "500px",
      data: {
        delete_body_text:
          "Are you sure you want to delete " + object.city + "?",
        delete_api_url: "/rhAPI/city/delete/",
        delete_id: object.city_id,
        delete_header_text: "Deleting " + object.city,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        this.cityService.deleteOne(object.city_id);
        this.log.info(
          this.usernamee +
            " deleted the city: " +
            object.city +
            " id: " +
            object.city_id
        );
      }
    });
  }
}
